import {useState, useCallback} from 'react';

function useToggle(initialValue = false) {
  const [value, setToggle] = useState(initialValue);
  const toggle = useCallback(() => setToggle(prev => !prev), [setToggle]);

  return [value, toggle];
}

export default useToggle;